import { createContext, useCallback, useContext, useEffect, useState } from "react";

const GameFactsContext = createContext();

export const useGamefacts = () => useContext(GameFactsContext)

export const GamefactsProvider = ({initialGamefacts = [], children}) => {

  const [gamefacts, setGamefacts] = useState([]);

  useEffect(() => {
      setGamefacts(initialGamefacts)

  }, [initialGamefacts])

    const deleteGamefact =  useCallback((id) => {

      let newGamefacts = gamefacts.filter(g => g._id !== id)

      setGamefacts(newGamefacts)
    }, [gamefacts])

    const createGamefact =  useCallback((gamefact) => {
      let newGamefacts = gamefacts.concat([gamefact])

      setGamefacts(newGamefacts)
    }, [gamefacts])

    const createGamefacts =  useCallback((ngamefacts) => {
      let newGamefacts = gamefacts.concat(ngamefacts)

      setGamefacts(newGamefacts)
    }, [gamefacts])

    const updateGamefact = useCallback((gamefact) => {

      let newGamefacts = gamefacts.map(g => {
        if(g._id === gamefact._id)
          return gamefact

        return g
      })

      setGamefacts(newGamefacts)
    }, [gamefacts])

    return (
        <GameFactsContext.Provider value={{ createGamefact, createGamefacts, updateGamefact, deleteGamefact, gamefacts }}>
            {children}
        </GameFactsContext.Provider>
    );
}